<template>
    <Breadcrumbs main="Form Controls" title="Input Mask" />
    <div class="container-fluid">
        <div class="row">
            <maskInput />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const maskInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputmask/maskInput.vue"))
</script>